import React from 'react';
import Loading from '../../../loading';
import Server from '../../../../functions/server'
import $ from "jquery";
import Adds from '../../../media/add.png';
import { Image } from 'semantic-ui-react';

class FeatureImage extends React.Component {

  state = {
    file: Adds,
  }

  componentDidMount() {
    this.getFeatureImages();
  }

  componentDidUpdate(props) {
    if (props.partCode != this.props.partCode) {
      this.getFeatureImages();
    }
  }

  getFeatureImages() {
    let context = this;
    let partCode = this.props.partCode;
    let data1 = { 'part_code': partCode };
    context.setState({
      load: true,
      message: 'Getting Feature Image!!!',
      file: Adds,
    });
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'spares/getfeatureimage.php',
      success: function(data)
      {
        let image, images;
        context.setState({
          load: false,
        });
        try {
          data = JSON.parse(data);
          for (var i = 0; i < data.length; i++) {
            image = data[i].feature;
            images = data[i].feature_image;
          }
        } catch (e) {

        }
        if (image.length <= 1) {

        }
        else {
          context.setState({ file: images })
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    });
  }

  handleFile = e => {
    this.updateLocalfile(e.target.files[0]);
    this.uploadFeatureimage(e.target.files[0]);
  }

  updateLocalfile(value) {
    let reader  = new FileReader();
    let context = this;
    reader.addEventListener("load", function () {
      let out = reader.result;
      context.setState({
        file: out
      });
    }, false);
    if (value) {
      reader.readAsDataURL(value);
    }
  }

  uploadFeatureimage(file) {
    let context = this;
    context.setState({
      load: true,
      message: 'Spare Feature image uploading!!!'
    });
    let partCode = this.props.partCode;
    var formData = new FormData();
    formData.append('partCode', partCode);
    formData.append('file', file);
    $.ajax({
    type: 'POST',
    processData: false,
    contentType: false,
    data: formData,
    url: Server() + 'spares/uploadfeatureimage.php',
    success: function(data)
    {
      console.log(data);
      context.setState({
        load: false,
      });
    },
    error: function(error) {
      context.setState({
        load: false,
      });
    }
    });
  }

  render() {
    const { load, message } = this.state;
    return (
      <div>
        <Loading load={load} message={message} />
        <input id='nice' type="file"
          onChange={this.handleFile}
          style={{display: 'none'}}/>
        <label htmlFor='nice'>
          <Image src={this.state.file}
            style={{height: 500, cursor: 'pointer'}} id='image'
            fluid />
        </label>
      </div>
    );
  }
}

export default FeatureImage;
